import React from 'react';
import { View, StyleSheet } from 'react-native';
import Icon from '../../icon/Icon';
import { ButtonSizeDLS, ButtonTypeDLS, ColorTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import { isMobileView } from '../../stack/utils';
export var PAN_TYPE_BE;
(function (PAN_TYPE_BE) {
    PAN_TYPE_BE["RESIDENT_INDIVIDUAL_SELF"] = "RESIDENT_INDIVIDUAL_SELF";
    PAN_TYPE_BE["RESIDENT_INDIVIDUAL_OTHER"] = "RESIDENT_INDIVIDUAL_OTHER";
    PAN_TYPE_BE["LLP"] = "LLP";
    PAN_TYPE_BE["HUF"] = "HUF";
    PAN_TYPE_BE["PRIVATE_LIMITED"] = "PRIVATE_LIMITED";
    PAN_TYPE_BE["INDIVIDUAL"] = "INDIVIDUAL";
    PAN_TYPE_BE["SOLE_PROPRIETOR"] = "SOLE_PROPRIETOR";
    PAN_TYPE_BE["PARTNERSHIP"] = "PARTNERSHIP";
    PAN_TYPE_BE["OPC"] = "OPC";
    PAN_TYPE_BE["OTHER"] = "OTHER";
})(PAN_TYPE_BE || (PAN_TYPE_BE = {}));
export var PAN_TYPE_LABEL;
(function (PAN_TYPE_LABEL) {
    PAN_TYPE_LABEL["RESIDENT_INDIVIDUAL_SELF"] = "Resident Individual (Self)";
    PAN_TYPE_LABEL["RESIDENT_INDIVIDUAL_OTHER"] = "Resident Individual (Other)";
    PAN_TYPE_LABEL["LLP"] = "Limited Liability Partnership";
    PAN_TYPE_LABEL["HUF"] = "HUF";
    PAN_TYPE_LABEL["PRIVATE_LIMITED"] = "PRIVATE_LIMITED";
    PAN_TYPE_LABEL["INDIVIDUAL"] = "INDIVIDUAL";
    PAN_TYPE_LABEL["SOLE_PROPRIETOR"] = "Sole proprietor";
    PAN_TYPE_LABEL["PARTNERSHIP"] = "Partnership";
    PAN_TYPE_LABEL["OPC"] = "OPC (One-Person Company)";
    PAN_TYPE_LABEL["OTHER"] = "Other";
})(PAN_TYPE_LABEL || (PAN_TYPE_LABEL = {}));
const PayoutDashboardPage = ({ width, bankAddedOn, navigateAction, panType, panNumber, gstNumber, bankAccountNumber, ifscCode, bankAccountVerified, triggerAction }) => {
    const handlePress = async () => {
        if (navigateAction)
            await triggerAction({
                ...navigateAction,
                payload: {
                    panType,
                    panNumber,
                    gstNumber,
                    bankAccountNumber,
                    ifscCode,
                },
            });
    };
    const renderEmptyScreen = () => {
        return (React.createElement(View, { style: { justifyContent: 'center', alignItems: 'center', flex: 1, marginTop: 48 } },
            React.createElement(Icon, { name: IconTokens.List, size: IconSizeTokens.XXXXXXXXL }),
            React.createElement(View, { style: { marginTop: 12 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, label: 'Payout details not added', color: ColorTokens.Grey_Night })),
            React.createElement(View, { style: { marginVertical: 16, paddingHorizontal: 16, paddingVertical: 8, backgroundColor: '#F1F3F5', borderRadius: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Add your payout details for hassle-free earnings', color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { width: isMobileView() ? '60%' : '30%' } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: 'Add payout details', onPress: handlePress, isDisabled: false }))));
    };
    const maskExceptLastFour = (str) => {
        if (str?.length <= 4) {
            return str;
        }
        const lastFour = str?.slice(-4);
        const maskedPart = 'xxxx';
        return maskedPart + lastFour;
    };
    const partnerPayoutDetails = () => {
        const bankDetails = ifscCode.substring(0, 4) + ' ' + maskExceptLastFour(bankAccountNumber);
        let panTypeDetail = '';
        switch (panType) {
            case PAN_TYPE_BE.RESIDENT_INDIVIDUAL_SELF:
                panTypeDetail = PAN_TYPE_LABEL.RESIDENT_INDIVIDUAL_SELF;
                break;
            case PAN_TYPE_BE.RESIDENT_INDIVIDUAL_OTHER:
                panTypeDetail = PAN_TYPE_LABEL.RESIDENT_INDIVIDUAL_OTHER;
                break;
            case PAN_TYPE_BE.LLP:
                panTypeDetail = PAN_TYPE_LABEL.LLP;
                break;
            case PAN_TYPE_BE.HUF:
                panTypeDetail = PAN_TYPE_LABEL.HUF;
                break;
            case PAN_TYPE_BE.PRIVATE_LIMITED:
                panTypeDetail = PAN_TYPE_LABEL.PRIVATE_LIMITED;
                break;
            case PAN_TYPE_BE.INDIVIDUAL:
                panTypeDetail = PAN_TYPE_LABEL.INDIVIDUAL;
                break;
            case PAN_TYPE_BE.SOLE_PROPRIETOR:
                panTypeDetail = PAN_TYPE_LABEL.SOLE_PROPRIETOR;
                break;
            case PAN_TYPE_BE.OPC:
                panTypeDetail = PAN_TYPE_LABEL.OPC;
                break;
            case PAN_TYPE_BE.OTHER:
                panTypeDetail = PAN_TYPE_LABEL.OTHER;
                break;
            case PAN_TYPE_BE.PARTNERSHIP:
                panTypeDetail = PAN_TYPE_LABEL.PARTNERSHIP;
                break;
            default: panTypeDetail = panType;
        }
        return (!isMobileView() ? (React.createElement(View, { style: { marginTop: 26, marginLeft: 36, width: '50%' } },
            React.createElement(View, { style: { width: '40%' } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Edit details', onPress: handlePress, isDisabled: false, newArchButton: false })),
            React.createElement(View, { style: { marginTop: 24, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Invoice details', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Bank details', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 20, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'PAN type', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'Bank account', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: panTypeDetail, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: bankDetails, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 20, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'PAN', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'IFSC', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: panNumber, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: ifscCode, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 20, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'GST', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'Last updated on', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }))),
            React.createElement(View, { style: { marginTop: 4, flexDirection: 'row' } },
                React.createElement(View, { style: { width: '50%' } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: gstNumber ? gstNumber : '---', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
                React.createElement(View, { style: { marginLeft: 60 } },
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: bankAddedOn ? bankAddedOn : '', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left }))))) : (React.createElement(View, { style: { marginTop: 26, marginHorizontal: 16 } },
            React.createElement(View, { style: { width: '60%' } },
                React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.SECONDARY, label: 'Edit details', onPress: handlePress, isDisabled: false })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Invoice details', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 20, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'PAN type', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: panTypeDetail, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 12, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'PAN', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: panNumber, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 12, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'GST', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: gstNumber ? gstNumber : '---', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 28 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Bank details', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 20, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'Bank account', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: bankDetails, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 12, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'IFSC', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: ifscCode, color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })),
            React.createElement(View, { style: { marginTop: 12, flexDirection: 'row', justifyContent: 'space-between' } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2M, label: 'Last updated on', color: ColorTokens.Grey_Smoke, textAlign: TextAlignTokens.left }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: bankAddedOn ? bankAddedOn : '', color: ColorTokens.Grey_Night, textAlign: TextAlignTokens.left })))));
    };
    return bankAccountVerified ? partnerPayoutDetails() : renderEmptyScreen();
};
const styles = StyleSheet.create({});
export default PayoutDashboardPage;
